import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { WithLayoutProps } from './withLayoutProps';
import { CSSProperties } from 'styled-components';

const flexboxMappedProps = {
  gap: true,
  columnGap: true,
  rowGap: true,
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true,
};

export type WithFlexboxProps = Omit<WithLayoutProps, 'd'> & {
  d?: 'flex' | 'inline-flex' | 'none';
  gap?: StyledPropType<CSSProperties['gap']>;
  columnGap?: StyledPropType<CSSProperties['columnGap']>;
  rowGap?: StyledPropType<CSSProperties['rowGap']>;
  justifyContent?: StyledPropType<CSSProperties['justifyContent']>;
  alignItems?: StyledPropType<CSSProperties['alignItems']>;
  alignContent?: StyledPropType<CSSProperties['alignContent']>;
  flexDirection?: StyledPropType<CSSProperties['flexDirection']>;
  flexWrap?: StyledPropType<CSSProperties['flexWrap']>;
  justifyItems?: StyledPropType<CSSProperties['justifyItems']>;
  // item
  flex?: StyledPropType<CSSProperties['flex']>;
  flexGrow?: StyledPropType<CSSProperties['flexGrow']>;
  flexShrink?: StyledPropType<CSSProperties['flexShrink']>;
  flexBasis?: StyledPropType<CSSProperties['flexBasis']>;
  justifySelf?: StyledPropType<CSSProperties['justifySelf']>;
  alignSelf?: StyledPropType<CSSProperties['alignSelf']>;
  order?: StyledPropType<CSSProperties['order']>;
};

export const withFlexbox = createExtractCssFromProps(flexboxMappedProps);
